import {RoleModel} from "../../shared/models/role/role.model";

export const adminRole: RoleModel = {
  name: 'admin-role',
  nameDutch: 'Beheerder',
  employee: {
        view: true,
        add: true,
        edit: true,
        delete: true,
    },
    customer: {
        view: true,
        add: true,
        edit: true,
        delete: true,
        addUser: true,
        editUser: true,
    },
    project: {
        view: true,
        others: true
    },
    firePartition: {
        view: true,
    },
    printQr: {
        view: true,
        generate: true,
    }
}
